// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1ryuz","label":"SetPasswdForm_label__3E0xp"};